export class UrgentCareWaitTimes extends DrupalBehavior {
  onContent(context) {
    const urgentCareComponents = once(
      'fetch-wait-times',
      '.urgent-care-wait-times--wrapper',
      context
    );

    this.buildUCWaitTimeData(urgentCareComponents);
  }

  buildUCWaitTimeData(urgentCareComponents) {
    urgentCareComponents.forEach((element) => {
      const elementGrandparent = element.parentElement.parentElement;
      const epicId = element.getAttribute('data-epic-id');
      const nodeId = element.getAttribute('data-node-id');
      const waitTimeTextElement = element.querySelector('.wait-time');
      const loader = element.querySelector('.loader');

      if (!epicId || !nodeId) return;

      fetch(`/api/urgent-care/wait-times?node_id=${nodeId}&epic_id=${epicId}`)
        .then((response) => response.json())
        .then((data) => {
          const UCInner = element.querySelector(
            '.urgent-care-wait-times--inner'
          );

          if (data.grey_bg) {
            UCInner.classList.add('grey-bg');
          }

          this.showWaitTimeText(
            waitTimeTextElement,
            loader,
            this.formatWaitTimeString(data.wait_time_string, elementGrandparent)
          );
        })
        .catch((error) => {
          console.error('Error fetching wait times:', error);
          this.showWaitTimeText(waitTimeTextElement, loader);
        });
    });
  }

  showWaitTimeText(
    waitTimeTextElement,
    loader,
    textContent = 'No wait time data available.'
  ) {
    waitTimeTextElement.textContent = textContent;
    loader.classList.add('hidden');
    waitTimeTextElement.classList.remove('hidden');
  }

  formatWaitTimeString(wait_time_string, grandparent) {
    if (grandparent.classList.contains('location-card')) {
      return wait_time_string
        .replace(/minutes/gi, 'min')
        .replace(/minute/gi, 'min')
        .replace(/hours/gi, 'hr')
        .replace(/hour/gi, 'hr');
    }

    return wait_time_string;
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'urgent_care_wait_times',
  UrgentCareWaitTimes
);
